import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ServicesComponent } from "../../components/info/ServicesComponent";
import { setShowSearch } from "../../store/appConfigsSlice";

const ServicesPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  return <ServicesComponent />;
};

export default withTranslation()(ServicesPage);
